(function () {
  const qs = (selector, scope) => (scope || document).querySelector(selector);
  const qsa = (selector, scope) => Array.from((scope || document).querySelectorAll(selector));

  const header = qs('[data-header]');
  const onScroll = () => {
    if (header) header.classList.toggle('is-scrolled', window.scrollY > 8);
  };
  window.addEventListener('scroll', onScroll, { passive: true });
  onScroll();

  const menuToggle = qs('[data-menu-toggle]');
  const siteNav = qs('[data-site-nav]');
  if (menuToggle && siteNav) {
    menuToggle.addEventListener('click', () => {
      const isOpen = siteNav.classList.toggle('is-open');
      menuToggle.setAttribute('aria-expanded', String(isOpen));
      menuToggle.querySelector('.sr-only').textContent = isOpen ? 'Close menu' : 'Open menu';
    });
    qsa('a', siteNav).forEach((link) => link.addEventListener('click', () => {
      siteNav.classList.remove('is-open');
      menuToggle.setAttribute('aria-expanded', 'false');
      menuToggle.querySelector('.sr-only').textContent = 'Open menu';
    }));
  }

  qsa('[data-product-gallery]').forEach((gallery) => {
    const main = qs('[data-product-main-image]', gallery);
    qsa('[data-gallery-thumb]', gallery).forEach((thumb) => {
      thumb.addEventListener('click', () => {
        if (!main) return;
        main.src = thumb.dataset.imageSrc;
        main.alt = thumb.dataset.imageAlt || '';
        qsa('[data-gallery-thumb]', gallery).forEach((item) => item.classList.remove('is-active'));
        thumb.classList.add('is-active');
      });
    });
  });

  const showToast = (message) => {
    const toast = qs('[data-cart-toast]');
    if (!toast) return;
    toast.textContent = message;
    toast.classList.add('is-visible');
    window.clearTimeout(showToast.timer);
    showToast.timer = window.setTimeout(() => toast.classList.remove('is-visible'), 3200);
  };

  const updateCartCount = () => {
    fetch(`${window.Shopify && Shopify.routes ? Shopify.routes.root : '/'}cart.js`)
      .then((response) => response.json())
      .then((cart) => {
        qsa('[data-cart-count]').forEach((count) => { count.textContent = cart.item_count; });
      })
      .catch(() => {});
  };

  qsa('[data-variant-select]').forEach((select) => {
    select.addEventListener('change', () => {
      const selected = select.options[select.selectedIndex];
      const price = qs('[data-product-price]', select.closest('.product-info'));
      if (price && selected && selected.dataset.price) price.textContent = selected.dataset.price;
    });
  });

  qsa('.product-info form[action*="/cart/add"], .product-info form[action*="cart/add"]').forEach((form) => {
    form.addEventListener('submit', (event) => {
      if (event.submitter && event.submitter.classList.contains('shopify-payment-button__button')) return;
      if (!window.fetch || !window.Shopify) return;
      event.preventDefault();
      const button = event.submitter || qs('button[name="add"]', form);
      if (!button || button.disabled) return;
      const original = button.innerHTML;
      button.disabled = true;
      button.textContent = 'Adding…';
      fetch(`${Shopify.routes.root}cart/add.js`, { method: 'POST', headers: { Accept: 'application/json' }, body: new FormData(form) })
        .then((response) => {
          if (!response.ok) throw new Error('Unable to add item');
          return response.json();
        })
        .then(() => {
          updateCartCount();
          showToast('Added to your cart.');
        })
        .catch(() => showToast('Something went wrong. Please try again.'))
        .finally(() => {
          button.disabled = false;
          button.innerHTML = original;
        });
    });
  });
})();
